'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _captionActions = require('./captionActions');

var _elementCaptionUtil = require('./elementCaptionUtil');

var _keyConstants = require('../../utils/keyboard/keyConstants');

var _captionConstants = require('./captionConstants');

var _analytics = require('../../analytics');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


// Actions


// Utils


// Constants


exports.default = function (DecoratedComponent) {
    var _dec, _class;

    var CaptionContainerDecorator = (_dec = (0, _reactRedux.connect)(), _dec(_class = function (_React$Component) {
        _inherits(CaptionContainerDecorator, _React$Component);

        function CaptionContainerDecorator() {
            var _ref;

            var _temp, _this, _ret;

            _classCallCheck(this, CaptionContainerDecorator);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CaptionContainerDecorator.__proto__ || Object.getPrototypeOf(CaptionContainerDecorator)).call.apply(_ref, [this].concat(args))), _this), _this.onEmptyBackspace = function () {
                var _this$props = _this.props,
                    isEditable = _this$props.isEditable,
                    dispatch = _this$props.dispatch,
                    element = _this$props.element,
                    stopEditing = _this$props.stopEditing;

                if (!isEditable) return;

                dispatch((0, _captionActions.setHideCaption)({ elementId: element.get('id') }));
                stopEditing();
            }, _this.captionKeyHandler = function (event) {
                var _this$props2 = _this.props,
                    stopEditing = _this$props2.stopEditing,
                    startEditing = _this$props2.startEditing,
                    element = _this$props2.element,
                    isEditing = _this$props2.isEditing;

                // Unfortunately have to handle the escape key separately as it's not causing a keypress event

                if (event.which === _keyConstants.KEY_CODES.ESC) {
                    stopEditing();
                    return;
                }

                // Unfortunately also have to handle this case to prevent an issue.
                if (event.which === _keyConstants.KEY_CODES.BACKSPACE) {
                    event.preventDefault();
                    return;
                }

                // don't trigger a start editing event when non-character keys are pressed
                if (_keyConstants.NON_CHARACTERS.indexOf(event.which) !== -1) {
                    return;
                }

                var showingCaption = (0, _elementCaptionUtil.getShowCaption)(element);
                if (!showingCaption) {
                    _this.showCaption();
                }

                if (isEditing) {
                    return;
                }

                startEditing(_captionConstants.CAPTION_EDITOR_KEY);
            }, _this.saveCaptionContent = function (caption, sync) {
                var _this$props3 = _this.props,
                    element = _this$props3.element,
                    isEditable = _this$props3.isEditable,
                    dispatchUpdateElement = _this$props3.dispatchUpdateElement;

                if (!isEditable) return;

                dispatchUpdateElement({
                    id: element.get('id'),
                    changes: { caption: caption },
                    sync: sync
                });
            }, _this.showCaption = function () {
                var _this$props4 = _this.props,
                    element = _this$props4.element,
                    isEditable = _this$props4.isEditable,
                    dispatch = _this$props4.dispatch;

                if (!isEditable) return;

                (0, _analytics.analyticsEvent)('added-' + element.get('elementType') + '-caption', { shortcut: true });

                dispatch((0, _captionActions.setShowCaption)({ elementId: element.get('id') }));
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }

        _createClass(CaptionContainerDecorator, [{
            key: 'render',
            value: function render() {
                return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, {
                    captionKeyHandler: this.captionKeyHandler,
                    saveCaptionContent: this.saveCaptionContent,
                    showCaption: this.showCaption,
                    onEmptyBackspace: this.onEmptyBackspace }));
            }
        }]);

        return CaptionContainerDecorator;
    }(_react2.default.Component)) || _class);


    CaptionContainerDecorator.propTypes = {
        element: _propTypes2.default.object.isRequired,
        dispatchUpdateElement: _propTypes2.default.func.isRequired,
        dispatch: _propTypes2.default.func,
        stopEditing: _propTypes2.default.func,
        startEditing: _propTypes2.default.func,
        showCaption: _propTypes2.default.func,
        isEditing: _propTypes2.default.bool,
        isEditable: _propTypes2.default.bool
    };

    return CaptionContainerDecorator;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/caption/captionContainerDecorator.js
// module id = 425
// module chunks = 0